import { useCallback, useSyncExternalStore } from 'react';

import { featureFlagClient } from './core/featureFlagClient';
import type { PortalFeatureFlagDefinition } from './featureFlagDefinition';

export function useFeatureFlagReady(definition: PortalFeatureFlagDefinition): boolean {
  const { provider } = definition;
  const subscribe = useCallback(
    (onStoreChange: () => void) => featureFlagClient.onChange(onStoreChange, { provider }),
    [provider]
  );
  const getSnapshot = useCallback(() => featureFlagClient.isReady({ provider }), [provider]);
  const getServerSnapshot = useCallback(() => false, []);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
